// extracted by mini-css-extract-plugin
export default {"DashboardLayout":"DashboardLayout_DashboardLayout__klYMK","LeftSection":"DashboardLayout_LeftSection__yUjGE","RightSection":"DashboardLayout_RightSection__0RKaQ"};